module.exports = __webpack_public_path__ + "img/10.c13e0376.png";